import { render, staticRenderFns } from "./ServerNotificationHandler.vue?vue&type=template&id=1674a563&"
import script from "./ServerNotificationHandler.vue?vue&type=script&lang=js&"
export * from "./ServerNotificationHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports